module.exports = __webpack_public_path__ + "static/memphis-b8f9c89c64b0fa18da29f0f89b42f71f.png";